var _mask, _g, _path, _path2, _mask2, _g2, _path3, _mask3, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKenjoLogoLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 232,
    height: 55,
    fill: "none",
    viewBox: "0 0 232 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "prefix__a",
    width: 55,
    height: 55,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 0h54.989v54.828H0V0z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M29.814 51.957c-.15.096-1.12.108-1.297.137h-1.679c-.177-.03-1.3-.04-1.45-.136C13.19 50.95 3.275 40.538 2.938 28.38 2.585 15.678 11.72 4.64 23.978 2.977c.594-.08 1.233-.144 1.836-.164h3.204C37.658 2.81 47 9.44 50.573 18.373c6.075 15.187-4.497 32.292-20.759 33.584zM54.9 24.977c-.154-1.454-.417-2.237-.64-3.328C51.33 7.285 37.157-2.178 22.507.433 8.057 3.008-2.005 17.129.339 31.545 3.542 51.246 25.463 61.18 42.266 50.411c7.45-4.774 11.99-11.803 12.689-20.745.1-1.883-.05-2.708-.044-4.465 0-.074-.003-.15-.011-.224z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M38.186 42.5c-.432.325-.91.594-1.387.854-1.059.575-2.013.452-2.665-.61-.672-1.096-.209-1.958.738-2.64.54-.387 1.103-.742 1.632-1.143 7.18-5.45 7.612-16.408.883-22.408-.726-.646-1.496-1.233-2.526-1.305l-.547-.077c-.389-.026-.457 0-.915 0-.305 0-.417.006-.488.03l-.217.059c-3.693 1.114-4.755 4.985-2.1 7.789.874.922 1.89 1.734 2.114 3.068.08.497.233 1.413.012 2.585-.722 2.4-2.35 3.742-4.827 3.932-2.142.163-4.137-1.179-5.001-3.192-.93-2.164-.436-4.217 1.647-6.146 1.483-1.375 2.023-3.007 1.49-4.887-.486-1.714-1.554-2.978-3.502-3.173-.57-.065-1.029-.065-1.829 0-2.423.334-3.724 2.191-4.947 3.935-4.707 6.713-2.878 15.875 3.967 20.415.252.166.518.311.767.482.997.687 1.31 1.637.708 2.67-.625 1.075-1.662 1.145-2.688.59-2.217-1.199-4.012-2.908-5.524-4.894-4.493-5.903-4.858-14.282-.944-20.635 3.864-6.27 11.46-9.768 18.492-8.515 7.765 1.384 13.773 7.007 15.138 14.477 1.416 7.747-1.198 14.007-7.48 18.738zm9.962-19.725c-1.949-8.796-9.056-15.256-18.06-16.423-.046-.005-.09-.014-.136-.025-1.714-.409-4.723-.005-4.723-.005-6.29.757-11.305 3.706-14.978 8.853-7.121 9.98-3.95 24.306 6.689 30.392 2.277 1.303 4.855.796 6.28-1.234 1.511-2.153 1.105-4.698-1.047-6.432-.47-.378-.996-.683-1.489-1.032-6.11-4.332-6.663-13.304-1.13-18.323.984-.893 2.081-1.445 3.183-.32 1.103 1.128.608 2.125-.45 3.082-1.369 1.238-2.398 2.74-2.467 4.696-.145 1.097-.152 1.373.028 2.87.739 4.027 4.127 6.54 8.434 6.257 3.76-.248 6.902-3.421 7.158-7.199.184-2.734-.82-4.958-2.831-6.763-.752-.674-1.077-1.47-.646-2.429.324-.72.926-1.105 1.734-1.09.79.015 1.327.526 1.863 1.017 5.801 5.318 4.827 14.16-2.07 18.794-2.516 1.692-3.266 4.5-1.788 6.706 1.547 2.313 4.248 2.755 6.85 1.122 7.756-4.867 11.539-13.743 9.596-22.514z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#59E37C",
    fillRule: "evenodd",
    d: "M30.101 27.429c-.019 1.331-1.084 2.353-2.445 2.346-1.33-.007-2.392-1.088-2.373-2.416.02-1.33 1.103-2.372 2.441-2.344 1.361.028 2.396 1.08 2.377 2.414z",
    clipRule: "evenodd"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    width: 23,
    height: 27,
    x: 67,
    y: 14,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M67.61 14.287h22V40.71h-22V14.287z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M80.547 25.681l8.916 13.638c.39.598-.038 1.392-.753 1.392h-5.514c-.303 0-.586-.153-.753-.407l-5.947-9.085c-.328-.502-1.046-.548-1.436-.093l-.816.952c-.14.163-.216.37-.216.585v7.148c0 .497-.403.9-.9.9H68.51c-.497 0-.9-.403-.9-.9V15.3c0-.497.403-.9.9-.9h4.618c.497 0 .9.403.9.9v4.647c0 .838 1.044 1.221 1.586.582l5.014-5.924c.171-.202.423-.318.687-.318h6.065c.766 0 1.181.894.688 1.48l-7.456 8.842c-.256.303-.282.74-.065 1.072z",
    clipRule: "evenodd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M103.35 14.325h18.849c.497 0 .9.403.9.9v4.655c0 .497-.403.9-.9.9h-12.432c-.496 0-.899.403-.899.9v1.71c0 .498.403.9.899.9h9.337c.497 0 .9.403.9.9v4.618c0 .497-.403.9-.9.9h-9.337c-.496 0-.899.403-.899.9v1.71c0 .498.403.9.899.9h12.432c.497 0 .9.403.9.9v4.618c0 .497-.403.9-.9.9H103.35c-.497 0-.899-.403-.899-.9V15.225c0-.497.402-.9.899-.9zM154.031 14.4h4.618c.497 0 .9.403.9.9V39.81c0 .497-.403.9-.9.9h-5.637c-.302 0-.585-.152-.751-.405l-8.425-12.791c-.491-.746-1.652-.399-1.652.494v11.727c0 .497-.402.9-.899.9h-4.618c-.497 0-.9-.403-.9-.9v-24.55c0-.496.403-.9.9-.9h5.675c.303 0 .585.153.751.405l8.388 12.72c.491.745 1.651.398 1.651-.495V15.3c0-.497.402-.9.899-.9zM185.905 14.287h6.418v16.238c0 5.479-4.484 10.097-9.962 9.996-5.313-.099-9.592-4.44-9.592-9.776v-.423c0-.642.52-1.162 1.162-1.162h4.093c.642 0 1.162.52 1.162 1.162v.301c0 1.786 1.342 3.35 3.124 3.474 1.955.135 3.595-1.424 3.595-3.352V14.287z",
    clipRule: "evenodd"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "prefix__c",
    width: 28,
    height: 28,
    x: 204,
    y: 13,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M204.972 13.947H232v27.028h-27.028V13.947z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#prefix__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M225.583 27.461c0-3.926-3.171-7.097-7.097-7.097-3.889 0-7.097 3.171-7.097 7.097 0 3.926 3.208 7.097 7.097 7.097 3.926 0 7.097-3.17 7.097-7.097zm6.417 0c0 7.474-6.04 13.514-13.514 13.514-7.436 0-13.514-6.04-13.514-13.514 0-7.436 6.078-13.514 13.514-13.514 7.474 0 13.514 6.078 13.514 13.514z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenjoLogoLarge);
export default __webpack_public_path__ + "static/media/kenjoLogoLarge.7fdb6dc61d8c9a970b918890f063c376.svg";
export { ForwardRef as ReactComponent };